import { removeUndefinedValues } from './ObjectUtils';

export const getJsonResponse = async <T>(response: Response): Promise<T> => {
  const data = await response.json();

  if (response.ok) {
    return data;
  }

  throw new Error(data.detail || data.title);
};

export const getGraphQlJsonResponse = async <T>(graphQlKey: string, response: Response): Promise<T> => {
  const data = await response.json();

  if (response.ok) {
    return data.data[graphQlKey];
  }

  throw new Error(data.detail || data.title);
};

export const toQueryParamsString = (params: Object, isStart = true) => {
  const nonUndefinedParams = removeUndefinedValues(params);
  return `${isStart ? '?' : '&'}${Object.keys(nonUndefinedParams)
    .map((key) => {
      if (Array.isArray(nonUndefinedParams[key])) {
        return nonUndefinedParams[key].map((value) => `${key}[]=${value ? value : ''}`).join('&');
      }

      return `${key}=${nonUndefinedParams[key] ? nonUndefinedParams[key] : ''}`;
    })
    .join('&')}`;
};

export const arrayToQueryString = (key: string, array: any[]) => {
  return `?${array.map((item) => `${key}[]=${item}`).join('&')}`;
};
